import React from 'react';
import { Briefcase, Plus, Download } from 'lucide-react';

const Portfolio = ({ showToast }) => {
  return (
    <div className="page-section">
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
          Portfolio Overview
        </h2>
        <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>
          Track your trading performance and watchlist
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '24px'
      }}>
        <div className="dashboard-card">
          <div className="card-header">
            <h3>Watchlist</h3>
            <button 
              className="card-action"
              onClick={() => showToast('info', 'Feature Coming Soon', 'Watchlist functionality will be available in a future update')}
            >
              <Plus size={14} style={{ marginRight: '4px' }} />
              Add Symbol
            </button>
          </div>
          <div className="card-content">
            <div className="empty-state">No symbols in watchlist</div>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h3>Analysis History</h3>
            <button 
              className="card-action"
              onClick={() => showToast('info', 'Feature Coming Soon', 'Export functionality will be available in a future update')}
            >
              <Download size={14} style={{ marginRight: '4px' }} />
              Export
            </button>
          </div>
          <div className="card-content">
            <div className="empty-state">No analysis history</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio